<template>
  <div class="notFound container my-64">
    <div class="flex items-center">
      <div class="flex items-center justify-center">
        <img class="inline-block" style="width: 108px;" src="~@/assets/images/not-found.svg" alt="">
      </div>
      <div class="pl-88">
        <h1 class="font-bold text-grey-darker mb-4">{{ $t('Oops') }} !</h1>
        <p class="text-xl font-bold text-grey-darker mb-8">{{ $t('notFoundPage') }}</p>
        <p class="text-md text-grey-dark mb-24">Error code: 404</p>
        <router-link :to="{name: 'Home'}" class="btn btn-text btn-blue pl-0 no-underline">{{ $t('backToHome') }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFoundStatus',
  metaInfo () {
    return {
      title: 'Oops！'
    }
  }
}
</script>

<style lang="sass" scoped>
.notFound
  @apply flex items-center justify-center
</style>
